<template>
  <div class="common-layout">
    <h1>产品详情页</h1>
  </div>

  <div class="productDetail_one">
      <img src="https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/images/1760170238822_2e8b810eea3411f3d7a7c45d5332a832.jpg" />
  </div>

  <div class="productDetail_two">
    <div class="two_left">
        <div class="two_left_top">
          <img src="https://s.niucache.com/static-shop/NiuHome/kqi3-cn/left-t.png" />
        </div>
        <div class="two_left_bottom">
          <img src="https://s.niucache.com/static-shop/NiuHome/kqi3-cn/left-b.png" />
        </div>
    </div>
    <div class="two_right">
       <img src="https://s.niucache.com/static-shop/NiuHome/kqi3-cn/right-c.jpg" />
    </div>
  </div>

  <div class="productDetail_three">
    <div class="three_top">
      <img src="https://s.niucache.com/static-shop/NiuI18n/kqi/model-03-3.png" />
    </div>
    <div class="three_middle">
        <div class="three_middle_left">
          <img src="https://s.niucache.com/static-shop/NiuI18n/kqi/model-03-4.png" />
        </div>
        <div class="three_middle_right">
          <img src="https://s.niucache.com/static-shop/NiuI18n/kqi/model-03-5.png" />
        </div>
    </div>
    <div class="three_bottom">
      <img src="https://s.niucache.com/static-shop/NiuHome/kqi3-cn/blue.png"/>
    </div>
  </div>

</template>


<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// 使用i18n进行国际化
const { t } = useI18n();
</script>

<style>
  .productDetail_one{
    width: 90%;
    /* height: 600px; */
    border-radius: 20px;
    /* border: 1px solid red; */
    margin: 0 auto;
    overflow: hidden; /* 防止图片溢出容器 */
  }

  .productDetail_two{
    width: 90%;
    /* height: 868px; */
    border-radius: 20px;
    /* border: 1px solid blue; */
    margin: 10px auto;
    display: flex;
     overflow: hidden; /* 防止图片溢出容器 */
  }

  .two_left{
    width: 50%;
    height: 100%;
    border-radius: 20px;
    /* border: 1px solid green; */
  }

  .two_left_top{
    width: 100%;
    height: 50%;
    border-radius: 20px;
    /* border: 3px solid green; */
  }
  .two_left_bottom{
    width: 100%;
    height: 50%;
    border-radius: 20px;
    /* border: 3px solid palevioletred; */
  }

   /* 添加以下样式让图片适应容器大小 */
  .two_left_top > img, .two_left_bottom > img,.two_right > img, .productDetail_one>img,.three_top>img, .three_middle_left>img, .three_middle_right>img, .three_bottom>img{
    width: 100%;
    height: 100%;
    object-fit: cover;
     border-radius: 20px;
  }



  .two_right{
    width: 50%;
    height: 100%;
    border-radius: 20px;
    /* border: 1px solid pink; */
  }

  .productDetail_three{
    width: 90%;
    /* height: 1200px; */
    /* border: 1px solid firebrick; */
    margin: 10px auto;
    border-radius: 20px;
    overflow: hidden; /* 防止图片溢出容器 */
  }

  .three_top{
    width: 100%;
    height: 15%;
    border-radius: 20px;
    /* border: 3px solid firebrick; */
  }
  .three_middle{
    width: 100%;
    height: 44%;
    border-radius: 20px;
    margin-top: 1%;
    /* border: 3px solid firebrick; */
  }

  .three_middle_left{
    width: 49%;
    height: 100%;
    border-radius: 20px;
    /* border: 3px solid firebrick; */
    float: left;
  }
  .three_middle_right{
    width: 49%;
    height: 100%;
    border-radius: 20px;
    /* border: 3px solid firebrick; */
    float: right;
  }


  .three_bottom{
    width: 100%;
    height: 39%;
    border-radius: 20px;
     margin-top: 1%;
    /* border: 3px solid firebrick; */
    overflow: hidden;
  }



</style>